// Encapsulate code in Immediately Invoked Functional Expression
(function() {

  // Invoke strict mode
  "use strict";

  /**
   * Object of DOM element references for the UI.
   *
   * @object ui
   */
  var ui = {};

  /**
   * Object to handle block related functionality.
   *
   * @object block
   */
  var block = {

    /**
     * Method to handle block initialization.
     *
     * @method block.init
     */
    init: function() {

      var options = doms(".myth-card");

      for (var index = 0; index < options.length; index++) {
        block.click(options[index]);
      }

      var blocks = doms(".block.myth");

      for (var index = 0; index < blocks.length; index++) {
        block.carousel.init(blocks[index]);
      }

    },

    /**
     * Method to handle on element click.
     *
     * @method block.click
     */
    click: function(element) {

      element.onclick = function(event) {
        if (event.target.classList.contains("button")) {
          element.classList.toggle("active");
        }
      }

    },

    /**
     * Object to handle carousel functionality.
     *
     * @property block.carousel
     */
    carousel: {

      /**
       * Method to handle carousel initialization.
       *
       * @method block.carousel.init
       */
      init: function(container) {

        var wrapper = dom(".myth-carousel-wrapper", container);
        var buttons = doms(".myth-navigation-wrapper-item-button", container);
        var items = doms(".myth-card", container);
        var count = items.length;
        var slide = 0;
        var width = window.innerWidth;
        var columns = width >= 1024 ? 3 : width >= 768 ? 2 : 1;
        var pages = Math.ceil(count / columns);

        if (pages > 1) {
          dom(".myth-navigation").classList.add("active");
        }

        for (var index = 0; index < buttons.length; index++) {
          buttons[index].onclick = function(event) {
            if (event.target.dataset.direction === "next") {
              if (slide < pages - 1) {
                slide += 1;
              } else {
                slide = 0;
              }
            } else {
              if (slide > 0) {
                slide -= 1;
              } else {
                slide = pages - 1;
              }
            }
            wrapper.style.transform = "translate3d(-" + (slide * 100) + "%, 0, 0)";
          };
        }

      },

    },

  };

  // Bind the init to the global block init event
  rgc.events.on("rgc.blocks.init", block.init.bind(block));

})();
